import { Controller } from 'react-hook-form';
import { Inputs, Label } from 'components';
import { FormAutoSuggestDropdownStyled } from './styled';

const FormAutoSuggestDropdown = ({
  control,
  name,
  label,
  subLabelColor,
  required = false,
  subLabel,
  errors,
  options = [],
  placeholder = 'เลือก',
  onChangeCustom,
  disabled,
  showAllOption = true,
  showSearch = true,
  fetchApi,
  category,
  params,
  heightInput,
  fontSize,
  minwidth,
  placeholderDropdownAll,
  iconColor,
  labelSize,
  labelFontFamily,
  labelColor,
  ...rest
}) => (
  <FormAutoSuggestDropdownStyled>
    <div className="box_input_item">
      <Label.LabelForm label={label} subLabelColor={subLabelColor} labelFontFamily={labelFontFamily} labelSize={labelSize} labelColor={labelColor} required={required} subLabel={subLabel} />
      <Controller
        control={control}
        name={name}
        defaultValue=""
        render={({ field }) => (
          <Inputs.AutoSuggestDropdown
            {...rest}
            theme_autosugget
            options={options}
            placeholderDropdown={placeholder}
            disabled={disabled}
            errors={errors}
            showAllOption={showAllOption}
            showSearch={showSearch}
            fetchApi={fetchApi}
            category={category}
            params={params}
            heightInput={heightInput}
            fontSize={fontSize}
            minwidth={minwidth}
            placeholderDropdownAll={placeholderDropdownAll}
            iconColor={iconColor}
            value={field.value}
            onChange={(e) => {
              field.onChange(e);
              onChangeCustom && onChangeCustom(e);
            }}
          />
        )}
      />
    </div>
  </FormAutoSuggestDropdownStyled>
);

export default FormAutoSuggestDropdown;
